export default function removeClass(el, classes) {
	if (!el) {
		return;
	}

	el.classList.remove(classes);
}
